import { useEffect } from "react";

const siteUrl = "https://mattiadelia.com";
const defaultImagePath = "/og.png?v=20260722";
const defaultImageAlt = "Mattia D'Elia — digital experiences and business systems.";

export function usePageMeta(
  title: string,
  description: string,
  path: string,
  imagePath = defaultImagePath,
  imageAlt = defaultImageAlt,
) {
  useEffect(() => {
    document.title = title;
    const meta = document.querySelector<HTMLMetaElement>('meta[name="description"]');
    const canonical = document.querySelector<HTMLLinkElement>('link[rel="canonical"]');
    const ogTitle = document.querySelector<HTMLMetaElement>('meta[property="og:title"]');
    const ogDescription = document.querySelector<HTMLMetaElement>('meta[property="og:description"]');
    const ogUrl = document.querySelector<HTMLMetaElement>('meta[property="og:url"]');
    const ogImages = document.querySelectorAll<HTMLMetaElement>(
      'meta[property="og:image"], meta[property="og:image:url"], meta[property="og:image:secure_url"]',
    );
    const ogImageAlt = document.querySelector<HTMLMetaElement>('meta[property="og:image:alt"]');
    const twitterTitle = document.querySelector<HTMLMetaElement>('meta[name="twitter:title"]');
    const twitterDescription = document.querySelector<HTMLMetaElement>('meta[name="twitter:description"]');
    const twitterImage = document.querySelector<HTMLMetaElement>('meta[name="twitter:image"]');
    const twitterImageAlt = document.querySelector<HTMLMetaElement>('meta[name="twitter:image:alt"]');
    const canonicalUrl = `${siteUrl}${path}`;
    const imageUrl = `${siteUrl}${imagePath}`;
    if (meta) meta.content = description;
    if (canonical) canonical.href = canonicalUrl;
    if (ogTitle) ogTitle.content = title;
    if (ogDescription) ogDescription.content = description;
    if (ogUrl) ogUrl.content = canonicalUrl;
    ogImages.forEach((image) => { image.content = imageUrl; });
    if (ogImageAlt) ogImageAlt.content = imageAlt;
    if (twitterTitle) twitterTitle.content = title;
    if (twitterDescription) twitterDescription.content = description;
    if (twitterImage) twitterImage.content = imageUrl;
    if (twitterImageAlt) twitterImageAlt.content = imageAlt;
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [description, imageAlt, imagePath, path, title]);
}
